import { isBefore } from 'date-fns';

// Compare the dates and return the latest date.
export const setEndNewEndDate = (
  inputDate: string | undefined | null,
  latestEndDate?: string
): string | undefined => {
  if (!inputDate && !latestEndDate) return;

  if (!inputDate && latestEndDate) {
    return latestEndDate;
  }

  if (inputDate && latestEndDate) {
    const savedDate = new Date(latestEndDate);
    const compareDate = new Date(inputDate);

    return isBefore(savedDate, compareDate) ? inputDate : latestEndDate;
  }

  return inputDate ?? undefined;
};
